import { Link } from "react-router-dom";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import HeroHome from "../Components/HeroHome";
import AboutSection from "../Components/AboutSection";
import Mission from "../Components/Mission";
import ExtraSection from "../Components/ExtraSection";

export default function Home() {
  return (
    <div>
      <Header />
      <main id="main" className="main min-height bg-bgWarm">
        <HeroHome />
        
        {/* Call to Action for Seva Prkalp */}
        <section className="relative z-10 -mt-16 mb-16 px-4 sm:px-6 lg:px-8 animate-fade-in-up">
          <div className="max-w-6xl mx-auto bg-white/20 backdrop-blur-xl border border-white/30 rounded-3xl p-6 md:p-8 shadow-[0_20px_50px_rgba(216,67,21,0.3)] bg-gradient-to-br from-main/95 to-accent/95 text-white transform transition duration-500 hover:-translate-y-2 hover:shadow-[0_25px_60px_rgba(216,67,21,0.5)] overflow-hidden">
            {/* Glowing orbs */}
            <div className="absolute top-0 right-0 w-48 h-48 bg-white/20 rounded-full blur-3xl pointer-events-none"></div>
            <div className="absolute bottom-0 left-0 w-56 h-56 bg-black/10 rounded-full blur-3xl pointer-events-none"></div>
            
            <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6 md:gap-10">
              <div className="text-center md:text-left flex-1">
                <h2 className="text-2xl md:text-3xl font-bold mb-3 font-Philosopher drop-shadow-md">
                  🌸 हमारे नए सेवा प्रकल्प से जुड़ें 🌸
                </h2>
                <p className="text-lg md:text-xl font-Philosopher drop-shadow-sm text-white/95 max-w-2xl">
                  भक्ति, गौसेवा, अन्नसेवा और मंदिर स्वच्छता के माध्यम से समाज में सेवा और संस्कार की भावना को बढ़ाएं।
                </p>
              </div>
              <div className="shrink-0">
                <Link 
                  to="/seva-prkalp" 
                  className="inline-block bg-white text-accent font-bold font-Philosopher text-lg py-3 px-8 rounded-full shadow-lg hover:shadow-2xl hover:scale-105 hover:bg-bgWarm transition-all duration-300"
                >
                  सेवा प्रकल्प के बारे में जानें
                </Link>
              </div>
            </div>
          </div>
        </section>

        <Mission />
        <AboutSection />
        <ExtraSection />
      </main>
      <Footer />
    </div>
  );
}
